import GHL from "V2.0/HomePages/HomeIntegrations/GHL";
import { IntegrationShell } from "../common/Shell";

export function GHLIntegration(props) {
  const { projectId, isViewOnly } = props;
  return (
    <IntegrationShell>
      <GHL projectId={projectId} isViewOnly={isViewOnly}/>
    </IntegrationShell>
  );
}
